import React from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';
import type { UsedPrecheckAnswer } from '../../../types/drbfm';
import { getPrecheckAnswerChipLabel } from './decisionMemoryText';

interface UsedPrecheckAnswerListProps {
  answers: UsedPrecheckAnswer[];
}

const UsedPrecheckAnswerList: React.FC<UsedPrecheckAnswerListProps> = ({ answers }) => {
  const { t } = useTranslation();

  return (
    <div>
      <p className="revy-cjk mb-2 text-sm font-medium leading-[1.5]">
        {t('drbfm.decisionMemory.usedPrecheckAnswers', '事前確認で使った回答')}
      </p>
      <div className="flex flex-col gap-2">
        {answers.map((answer, index) => (
          <div
            key={answer.id || answer.requiredContextKey || answer.question || index}
            className="rounded-md border p-2.5"
          >
            <div className="flex flex-col gap-2">
              {answer.question && (
                <p className="revy-cjk text-sm font-semibold leading-[1.6]">{answer.question}</p>
              )}
              <div>
                <Badge
                  variant={answer.status === 'unknown' ? 'warning' : 'secondary'}
                  className="revy-cjk max-w-full"
                >
                  {getPrecheckAnswerChipLabel(answer, t)}
                </Badge>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default UsedPrecheckAnswerList;
